import { Link } from 'react-router-dom';

const columns = [
  {
    title: '浏览',
    links: [
      { to: '/category/movie', label: '电影' },
      { to: '/category/series', label: '电视剧' },
      { to: '/category/short', label: '短视频' },
      { to: '/search', label: '搜索' },
    ],
  },
  {
    title: '关于',
    links: [
      { to: '/about', label: '关于我们' },
      { to: '/contact', label: '联系我们' },
      { to: '/about', label: '服务宗旨' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-20 border-t-2 border-primary-500/70 bg-background-200">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-950">
                <i className="ri-moon-clear-fill text-2xl"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">午夜视频</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              午夜视频是一个聚焦电影、电视剧与短视频的内容聚合平台，为影视爱好者提供精选片单、分类浏览与便捷搜索，
              打造沉浸式的午夜观影体验。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-wechat-fill', 'ri-weibo-fill', 'ri-bilibili-fill', 'ri-mail-fill'].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50 text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-lg`}></i>
                </span>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 tracking-wide">{col.title}</h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-300/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">© {new Date().getFullYear()} 午夜视频 Midnight Video · 本站影视内容均为演示数据</p>
          <p className="text-xs text-foreground-500">精选影视，畅享午夜时光</p>
        </div>
      </div>
    </footer>
  );
}